import { createApp } from 'vue'
import { setupAppErrorHandling } from '../vue-app-helper'

export function createSubApp({ component, container, scope, props, plugins = [] }) {
  const app = createApp(component, props)
  plugins.forEach((plugin) => {
    if (plugin) app.use(plugin)
  })
  setupAppErrorHandling(app, scope)
  const rootInstance = app.mount(container)
  app.rootInstance = rootInstance
  return app
}
